// extracted by mini-css-extract-plugin
export default {"root":"promoteVipPopupInfo_root__kAuBk","icon":"promoteVipPopupInfo_icon__3ZvpJ","info":"promoteVipPopupInfo_info__RHtlZ"};